import { useRef, useEffect } from 'preact/hooks';
import { useSignal } from '@preact/signals';

export const useRevealAnimation = ({
	animationOpenClass,
	animationCloseClass,
	isOpen,
}: {
	animationOpenClass: string;
	animationCloseClass: string;
	isOpen: boolean;
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const elementClassSignal = useSignal('hidden');
	const turnedOnFirstAnimation = useSignal(false);

	useEffect(() => {
		if (!ref.current) {
			console.error('Ref is not set');
			return;
		}

		if (isOpen && !turnedOnFirstAnimation.value) {
			turnedOnFirstAnimation.value = true;
		}

		if (isOpen) {
			elementClassSignal.value = animationOpenClass;

			return;
		} else if (turnedOnFirstAnimation.value) {
			const handleAnimationEnd = () => {
				ref.current?.removeEventListener('animationend', handleAnimationEnd);
				elementClassSignal.value = 'hidden';
			};

			elementClassSignal.value = animationCloseClass;
			ref.current.addEventListener('animationend', handleAnimationEnd);

			return () => {
				ref.current?.removeEventListener('animationend', handleAnimationEnd);
			};
		}

		return;
	}, [isOpen]);

	return {
		ref,
		elementClassSignal,
	};
};
